module.exports = __webpack_public_path__ + "static/media/team.e39fcc9e.svg";